import React, { useState, useEffect, useRef } from 'react';

// Page 2 Component - blurb
const Page2 = () => {
  return (
    <div className="flex w-full flex-col snap-start min-w-full h-full">
        <div className="relative z-10">
            <h2 className="about-blurb p2 max-w-4xl opacity-0 animate-fade-in"
            style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>Custom apps for early-stage companies bringing new ideas to life. Modern websites for established businesses ready to grow their digital presence.
            <div id="startups">
             <span>For Startups</span> <br></br> MVP development  /  custom web & mobile apps  /  technical strategy
            </div>
            <div id="businesses">
              <span>For Businesses</span> <br></br> high-converting websites  /  e-commerce platforms  /  platform modernization
            </div>
            <div id="everyone">
              <span>For Everyone</span> <br></br> technical consulting  /  strategic guidance
            </div>
            </h2>
        </div>
    </div>
  );
};

export default Page2;